import _regenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import { login as _login, logout as _logout, getInfo as _getInfo, getMenusApi } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import Cookies from 'js-cookie';
import { formatFlatteningRoutes, findFirstNonNullChildren } from '@/utils/system.js';
var state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  marginStatus: 0,
  marginDays: '',
  roles: [],
  menuList: JSON.parse(localStorage.getItem('MerMenuList')),
  sidebarWidth: window.localStorage.getItem('sidebarWidth'),
  sidebarStyle: window.localStorage.getItem('sidebarStyle'),
  oneLvMenus: [],
  oneLvRoutes: JSON.parse(localStorage.getItem('oneLvRoutes')),
  childMenuList: []
};
var mutations = {
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    state.menuList = menuList;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_SIDEBAR_WIDTH: function SET_SIDEBAR_WIDTH(state, width) {
    state.sidebarWidth = width;
  },
  SET_SIDEBAR_STYLE: function SET_SIDEBAR_STYLE(state, style) {
    state.sidebarStyle = style;
    window.localStorage.setItem('sidebarStyle', style);
  },
  SET_MARGIN_STATUS: function SET_MARGIN_STATUS(state, status) {
    state.marginStatus = status;
  },
  SET_MARGIN_DAYS: function SET_MARGIN_DAYS(state, days) {
    state.marginDays = days;
  },
  setOneLvMenus: function setOneLvMenus(state, oneLvMenus) {
    state.oneLvMenus = oneLvMenus;
  },
  setOneLvRoute: function setOneLvRoute(state, oneLvRoutes) {
    state.oneLvRoutes = oneLvRoutes;
  },
  childMenuList: function childMenuList(state, list) {
    state.childMenuList = list;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    // const { username, password } = userInfo
    return new Promise(function (resolve, reject) {
      _login(userInfo).then(function (response) {
        var data = response.data;
        var arr = formatFlatteningRoutes(router.options.routes);
        var routes = formatFlatteningRoutes(response.data);
        localStorage.setItem('oneLvRoutes', JSON.stringify(routes));
        commit('setOneLvMenus', arr);
        commit('setOneLvRoute', routes);
        commit('SET_TOKEN', data.token);
        setToken(data.token);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getMenus: function getMenus(_ref2) {
    var _this = this;
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      getMenusApi().then(function (response) {
        commit('SET_MENU_LIST', response.data);
        localStorage.setItem('MerMenuList', JSON.stringify(response.data));
        resolve(response);
      }).catch(function (error) {
        _this.$message.error(error.message);
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar,
          introduction = data.introduction;
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        removeToken();
        resetRouter();
        // 清除所有可能的Cookie（包括不同domain设置的）
        Cookies.remove('merchantToken', {
          domain: '.zszhenhuixuan.com',
          path: '/'
        });
        Cookies.remove('merchantToken', {
          path: '/'
        }); // 清除当前域名的Cookie
        Cookies.remove(); // 清除所有Cookie（如果有其他Cookie需要清除）
        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      // 同时清除所有可能的Cookie（包括不同domain设置的）
      Cookies.remove('merchantToken', {
        domain: '.zszhenhuixuan.com',
        path: '/'
      });
      Cookies.remove('merchantToken', {
        path: '/'
      }); // 清除当前域名的Cookie
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};